import enMessages from "../locales/en";
import idMessages from "../locales/id";

const supported = ["en", "id"];
let locale = "en";

try {
  // get browser default language
  const { 0: browserLang } = navigator.language.split("-");

  if (supported.includes(browserLang)) locale = browserLang;
} catch (e) {
  console.log(e);
}

export default {
  // current locale
  locale,

  // when translation is not available fallback to that locale
  fallbackLocale: "en",

  // availabled locales for user selection
  availableLocales: [
    {
      code: "id",
      flag: "flag-indonesia",
      name: "bahasa-indonesia",
      label: "Bahasa Indonesia",
      messages: idMessages,
    },
    {
      code: "en",
      flag: "flag-united-states",
      name: "united-states",
      label: "English",
      messages: enMessages,
    },
  ],
  messages: {
    en: enMessages,
    id: idMessages,
  },
};
